document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".seemore").forEach(function (seemoreBtn) {
    const items = seemoreBtn.parentElement.querySelectorAll("li")

    seemoreBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const hiddenItems = seemoreBtn.parentElement.querySelectorAll("li.hidden")
      const isExpanded = hiddenItems.length === 0;

      items.forEach((item, i) => {
        if (i >= 5) {
          console.log(item.classList);
          if (item.classList.contains("seemore")) {
            return;
          }
          item.classList.toggle("hidden", isExpanded);
        }
      });

      seemoreBtn.querySelector("a").textContent = isExpanded ? "Show more" : "Show less";
    });
  });
});